<template>
  <div id="file-brows-dialog">
    <el-dialog
      title="新建文件夹"
      :visible.sync="newDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
    >
      <el-form
        :model="newForm"
        :rules="rules"
        ref="newForm"
        label-width="100px"
      >
        <el-form-item label="文件夹名称" prop="file">
          <el-input v-model="newForm.file" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="formReset('newForm')"
          >取 消</el-button
        >
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('newForm')"
          >创 建</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="上传文件"
      :visible.sync="uploadDialog"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-upload
        drag
        multiple
        collapse-tags
        :auto-upload="false"
        with-credentials
        ref="upload"
        class="upload"
        :action="upload"
        name="file"
        :limit="5"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :data="filedata"
        :headers="header"
        :on-exceed="exceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击选取</em>
        </div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="stopUpload()">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submitForm()"
          >立即上传</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FileBrowsDialog",
  props: {
    newDialog: {
      type: Boolean,
      default: false
    },
    uploadDialog: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      newForm: {
        file: ""
      },
      rules: {
        file: [
          {
            required: true,
            message: "请输入文件目录",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    upload() {
      let path = this.$http.defaults.baseURL || "";
      return path + "/gavial/v1/file/admin/putFile"; // 上传地址
    },
    header() {
      return {
        "X-Requested-Type": this.$store.state.requestHeader
      };
    },
    filedata() {
      return {
        dst: this.path
      };
    }
  },
  methods: {
    stopUpload() {
      this.$refs.upload.abort();
      this.formReset();
    },
    formReset(form) {
      if (form) {
        this.$refs[form].resetFields();
      } else {
        this.$refs.upload.clearFiles();
      }
      this.$emit("closeDialog");
    },
    submitForm(form) {
      if (form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            this.newFolder();
          }
        });
      } else {
        if (this.$refs.upload.uploadFiles.length === 0) {
          this.$message({
            type: "warning",
            message: "请选择一个文件"
          });
        } else {
          this.loading = true;
          this.$refs.upload.submit();
        }
      }
    },
    newFolder() {
      this.loading = true;
      this.$http
        .get(
          `/gavial/v1/file/admin/mkdir?name=${this.newForm.file}&parentDir=${this.path}`
        )
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${this.newForm.file} 文件夹创建成功!`,
            type: "success",
            duration: 2000
          });
          this.formReset("newForm");
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadSuccess() {
      this.$notify({
        title: "成功",
        message: "文件上传成功",
        type: "success",
        duration: 2000
      });
      this.loading = false;
      this.formReset();
      this.$emit("refush");
    },
    uploadError(err) {
      this.loading = false;
      let reg = /"msg":"([\w*\s*]+)"/gi;
      if (reg.test(err)) {
        let msg = reg.exec(err);
        this.$notify.error({
          title: "错误",
          message: msg[1],
          duration: 2000
        });
      }
    },
    exceed() {
      this.$message({
        type: "error",
        message: "选中文件个数超出限制(5个)！"
      });
    }
  }
};
</script>

<style lang="scss">
.el-upload {
  width: 100%;
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
